// import styles from "./Styles/LoadingBar.module.scss";
// function LoadingBar(){
//     return(
// <div className={styles.container}>
//     <div className={styles.circle}></div>
// </div>
//     )
// }

// export default LoadingBar;


////////////////////////////////
import { useState, useEffect } from "react";
import styles from "./Styles/LoadingBar.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHammer } from "@fortawesome/free-solid-svg-icons";

function LoadingBar() {
  const [currentLetterIndex, setCurrentLetterIndex] = useState(0);
  const letters = ["ი", "ტ", "ვ", "ი", "რ", "თ", "ე", "ბ", "ა"];
  
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentLetterIndex((prevIndex) => (prevIndex + 1) % letters.length);
    }, 500); // Change letter every 500ms
    
    return () => clearInterval(interval);
  }, [letters.length]);

  return (
    <div className={styles.container}>
      <div className={styles.textWrapper}>
        <div className={styles.hammerContainer}>
          <FontAwesomeIcon 
            icon={faHammer} 
            className={styles.hammer} 
            style={{ 
              left: `calc(${currentLetterIndex * 20}px + 10px)`,
              transformOrigin: 'bottom right'
            }}
          />
        </div>
        
         <div className={styles.text}>
          {letters.map((letter, index) => (
            <span 
              key={index} 
              className={`${styles.letter} ${index === currentLetterIndex ? styles.active : ''}`}
            >
              {letter}
            </span>
          ))}
         </div>
      </div>
    </div>
  );
}

export default LoadingBar;